import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../App'
import { useGetInsightsQuery } from '../__generated__/api-types-and-hooks'
import { useEffect, useMemo } from 'react'

export const useUnreadInsightsCount = () => {
  const { tenantId } = useParams<{ tenantId: string }>()
  const userId = useSelector((state: RootState) => state.user.user.id)

  const isEnabled = !!tenantId && !!userId
  const { data: allInsightsData } = useGetInsightsQuery(
    { tenantId: tenantId!, userId },
    {
      enabled: isEnabled,
    }
  )

  // Then fetch only unviewed insights
  const { data, refetch, isLoading, isError } = useGetInsightsQuery(
    { tenantId: tenantId!, userId, hasBeenViewed: false },
    {
      refetchOnWindowFocus: true,
      enabled: isEnabled,
      // Poll every 30 seconds to keep counter updated
      refetchInterval: 30000,
    }
  )

  // Count insights where hasBeenViewed is false or null/undefined (not yet set)
  const count = useMemo(() => {
    if (!isEnabled || !allInsightsData?.getInsights?.items) return 0

    const unviewedCount = allInsightsData.getInsights.items.filter(
      (insight) => !insight.hasBeenViewed
    ).length

    return unviewedCount
  }, [allInsightsData, isEnabled])

  useEffect(() => {}, [allInsightsData, count, tenantId, userId, isEnabled])

  useEffect(() => {}, [data, tenantId, userId, isLoading, isError, isEnabled])

  return { count, refetch }
}
